import CustomToastContainer from "components/customToastContainer";
import "./App.css";
import AppRoutes from "./routes";
import { BrowserRouter } from "react-router-dom";
import { ThemeContextProvider } from "theme/ThemeContextProvider";

function App() {
  return (
    <ThemeContextProvider>
      <BrowserRouter>
        <AppRoutes />
        <CustomToastContainer />
      </BrowserRouter>
    </ThemeContextProvider>
  );
}

export default App;
